export const GtagKeys = {
    gtagClientId: 'gtagClientId',
};
